<section>
  <div class="container">
    <h2>IFA Management Team</h2>
    <div class="clearfix mb-3"></div>

    <div class="row mb-2">
      @for (manager of managers; track manager) {
        <div class="col-lg-3 col-md-4 col-sm-6">
          <app-manager-card [data]="manager"></app-manager-card>
        </div>
      }
    </div>

  </div>
</section>